
export class GetProjectInfo {
  static readonly type = '[Unsubscribe] Get Project Info';
  constructor(public projectId: number) {}
}

export class ClearErrorAndMessage {
  static readonly type = '[Unsubscribe] ClearErrorAndMessage';
}


export class SetError {
  static readonly type = '[Unsubscribe] Set Error';
  constructor(public error: string) {}
}

export class EmailUnsubscribe {
  static readonly type = '[Unsubscribe] Unsubscribe';
  constructor(public emailAddress: string, public projectId: number) {}
}
